import { render, staticRenderFns } from "./zposterdialog.vue?vue&type=template&id=7840da3a&scoped=true"
import script from "./zposterdialog.vue?vue&type=script&lang=js"
export * from "./zposterdialog.vue?vue&type=script&lang=js"
import style0 from "./zposterdialog.vue?vue&type=style&index=0&id=7840da3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840da3a",
  null
  
)

export default component.exports